import { FormProvider, useForm } from "react-hook-form";
import { GeneralAssetType, generalAssetValidation, useGetCode } from "../../utils";
import { FormSectionTabGeneralAsset } from "../FormSection";
import { yupResolver } from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { useContext, useEffect, useState } from "react";
import { FormDataContext } from "../../context";
import { defaultValueGeneralAsset } from "../../utils/vars";

export function TabGeneralAsset(): JSX.Element {
    const api = useApi()

    // context
    const { setActiveTab, setAssetId, refecth, dataAsset } = useContext(FormDataContext)

    // state
    const [groupCode, setGroupCode] = useState<string>("")

    // hooks
    const { code } = useGetCode({ group_code: groupCode })

    const method = useForm<GeneralAssetType>({
        defaultValues: defaultValueGeneralAsset(dataAsset ?? {}),
        resolver: yupResolver(generalAssetValidation)
    })

    useEffect(() => {
        if (code && groupCode !== "") {
            method.setValue("asset_code", code)
        }
        // eslint-disable-next-line
    }, [code])


    useEffect(() => {
        if (dataAsset) {
            method.reset(defaultValueGeneralAsset(dataAsset));
        }
        // eslint-disable-next-line
    }, [dataAsset, method.reset]);

    const onSubmit = (data: GeneralAssetType) => {

        const formData = new FormData()

        Object.entries(data).forEach(([key, value]) => {
            if (value instanceof File || value instanceof Blob) {
                formData.append(key, value);
            } else if (key !== "asset_foto") {
                formData.append(key, String(value));
            }
        });
        
       
        if (!data.asset_foto || !(data.asset_foto instanceof File)) {
            formData.delete("asset_foto");
        }

        const url = dataAsset?.asset_id
            ? `/assetdepre/register_asset?asset_id=${dataAsset?.asset_id}`
            : "/assetdepre/register_asset";

        return new Promise<void>((resolve) => {
            toast.promise(
                api.post(url, formData),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.message ?? err.response.message
                }
            ).then((res) => {
                setActiveTab({
                    value: "profile"
                })

                setAssetId(res.data.payload[0].asset_id)
                refecth()

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;

            }).catch(() => { }).finally(resolve)
        })
    }

    return (
        <FormProvider {...method}>
            <FormSectionTabGeneralAsset
                onSubmit={method.handleSubmit(onSubmit)}
                setGroupCode={setGroupCode}
            />
        </FormProvider>
    )
}